export { default as getInboxCounters } from './getInboxCounters';

export type Actions = import('./getInboxCounters').Actions;
